import clsx from 'clsx';
import React, { useCallback, useState } from 'react';
import Tree from 'react-animated-tree';
import ReactTooltip from 'react-tooltip';

const treeStyles = {
  position:     'absolute',
  top:          5,
  left:         20,
  color:        'white',
  fill:         'white',
  fontSize:     '0.9rem',
  paddingRight: '10px',
  fontWeight:   '700'
};

const typeStyles = {
  fontSize:      '2em',
  verticalAlign: 'middle'
};

const typePdf  = <span style={typeStyles}><i className='fas fa-file-pdf'></i></span>;
const typeMark = <span style={typeStyles}><i className='fas fa-map-marker-alt'></i></span>;


const TreeFile = React.memo(({file, selected = false, onClickFile}) => {
  const textContent =
          <span data-tip={file.nome}>
            <span className='text-wrap'>{file.nome}</span>
          </span>;

  return (
    <div className={clsx('cursor-pointer-node', selected && 'node-selected')} onClick={() => onClickFile(file)}>
      <Tree type={typePdf} content={textContent} />
    </div>
  );
});

const TreeSetor = React.memo(({item, onClickFile, itemSelected}) => {
  const {setor, documentos} = item;

  return (
    <div>
      <Tree type={typeMark} content={setor}>
        {documentos.map((file) => <TreeFile key={file.id}
                                            file={file}
                                            selected={itemSelected === file.id}
                                            onClickFile={onClickFile} />)}
      </Tree>
    </div>
  );
});


const TreeProcesso = React.memo(({numero, itens, handleShowFile, processandoPdf}) => {
  const {capa, resumo, setores}         = itens;
  const [itemSelected, setItemSelected] = useState(null);

  const handleClickFile = useCallback((file) => {
    if (!processandoPdf && file.id != itemSelected) {
      setItemSelected(file.id);
      handleShowFile(file);
    }
  }, [itemSelected, processandoPdf]);

  return (
    <>
      <Tree content={numero} open style={treeStyles}>
        <TreeFile file={capa} selected={itemSelected === capa.id} onClickFile={handleClickFile} />

        {setores.map((item, idx) => <TreeSetor key={`${item.setor}_${idx+1}`}
                                          item={item}
                                          itemSelected={itemSelected}
                                          onClickFile={handleClickFile} />)}

        <TreeFile file={resumo} selected={itemSelected === resumo.id} onClickFile={handleClickFile} />
      </Tree>
      <ReactTooltip place='right' effect='solid' className='custom-theme-tooltip' />
    </>
  );
});

export default TreeProcesso;
